import intl from "react-intl-universal";
import { TbPlus } from "react-icons/tb";

/**
 * Dashed "Criar instância" tile — same flex rhythm as program cards so the
 * admin row does not leave a skinny stub with empty space beside it.
 */
export const BaasCreateInstanceCard = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="group flex h-full min-h-[220px] min-w-0 w-full flex-col items-center justify-center self-stretch rounded-2xl border-2 border-dashed border-gray-200 bg-gray-50/40 p-4 text-center transition duration-200 hover:-translate-y-0.5 hover:border-[#e7a73f] hover:bg-brand-cream/40 hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e7a73f]/50 dark:border-brand-dark-border dark:bg-brand-dark-elevated/20 dark:hover:border-brand-gold-mid dark:hover:bg-brand-dark-elevated/40"
  >
    <div className="flex h-12 w-12 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition group-hover:border-[#e7a73f]/60 group-hover:text-[#e7a73f] dark:border-brand-dark-border dark:bg-brand-dark-surface dark:text-gray-400 dark:group-hover:border-brand-gold-mid dark:group-hover:text-brand-gold-mid">
      <TbPlus className="h-6 w-6" />
    </div>
    <p className="mt-3 text-sm font-semibold text-brand-dark dark:text-gray-100">
      {intl.get("baas.instances.createCard")}
    </p>
  </button>
);
